import React from "react"
import { BeatLoader } from "react-spinners"

export type LoadingIndicatorProps = {
  color?: string
}

const LoadingIndicator = ({ color = 'var(--primary)'}: LoadingIndicatorProps) => {
  return (
    <div className="loading-indicator flex justify-center items-center px-2">
      <BeatLoader color={color} />
    </div>
  )
}

export default LoadingIndicator
